import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Tab = props => {
  const { active, children } = props;
  const cls = classnames('cr-width-full', {
    'cr-flex': active,
    'cr-display-none': !active,
  });
  return <div className={cls}>{children}</div>;
};

Tab.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
};

Tab.defaultProps = {
  active: false,
};

export default Tab;
